<template>
    <div>
        <div class="fw-userinfo">
            <img v-if="userInfo.sex==1" src="../../assets/empnan.png" class="u-img">
            <img v-if="userInfo.sex==0" src="../../assets/empnv.png" class="u-img">
            <div class="u-info">
                <div style="display: flex;">
                    <span style="font-size: 15px;font-weight: bold">{{userInfo.nickName}}</span>
                    <span style="font-size: 11px;margin-left: 8px;font-weight: bold;line-height: 18px">( {{userInfo.describe}} )</span>
                </div>
                <div style="color:#B5B1B0;display: flex;margin-top: 5px">
                    <span style="font-size: 13px;line-height: 20px">{{userInfo.deptName}}</span>
                    <span style="font-size: 11px;margin-left: 5px;line-height: 20px" v-if="userInfo.expireStr">有效时间: {{userInfo.expireStr}}</span>
                </div>
            </div>
        </div>
        <div class="fw-ywbl" v-if="!isCk">
            <div class="fw-ywbl-bt">
                <span style="line-height: 16px;">业务办理</span>
                <span style="font-size: 9px;">YE WU BAN LI</span>
            </div>
            <div class="fw-home-menu" v-if="!isCk">
                <div class="fw-menu-item" @click="toOperate">
                    <img src="./../../assets/homemenu/yyfx.png">
                    <span>运营分析</span>
                </div>
                <div class="fw-menu-item" @click="toTg">
                    <img src="./../../assets/homemenu/tgfx.png">
                    <span>推广分析</span>
                </div>
                <div class="fw-menu-item" @click="toMsAnalysis">
                    <img src="./../../assets/homemenu/spgl.png">
                    <span>秒杀分析</span>
                </div>
                <div class="fw-menu-item" @click="toOrder">
                    <img src="./../../assets/homemenu/ddgl.png">
                    <span>订单管理</span>
                </div>
            </div>
        </div>
        <div class="fw-ywbl" v-if="!isCk">
            <div class="fw-ywbl-bt">
                <span style="line-height: 16px;">门店管理</span>
                <span style="font-size: 9px;">MEN DIAN GUAN LI</span>
            </div>
            <div class="fw-home-menu" >
                <div class="fw-menu-item" @click="">
                    <img src="./../../assets/homemenu/zbyye.png">
                    <span>营业额</span>
                </div>
                <div class="fw-menu-item" @click="">
                    <img src="./../../assets/homemenu/zbyjmx.png">
                    <span>业绩明细</span>
                </div>
                <div class="fw-menu-item" @click="">
                    <img src="./../../assets/homemenu/zbyjfw.png">
                    <span>服务明细</span>
                </div>
                <div class="fw-menu-item" @click="">
                    <img src="./../../assets/homemenu/zbrxb.png">
                    <span>热销榜</span>
                </div>
            </div>
        </div>
        <div class="fw-ywbl" v-if="!isCk">
            <div class="fw-ywbl-bt">
                <span style="line-height: 16px;">其他</span>
                <span style="font-size: 9px;">QI TA</span>
            </div>
            <div class="fw-home-menu" >
                <div class="fw-menu-item" @click="toRenew">
                    <img src="./../../assets/homemenu/zbmdxf.png">
                    <span>门店续费</span>
                </div>
                <div class="fw-menu-item" @click="toPoster">
                    <img src="./../../assets/homemenu/zbhb.png">
                    <span>生成海报</span>
                </div>
                <div class="fw-menu-item" @click="toOrders">
                    <van-icon class="iconfont icon-weixinzhifu" size="18" style="display: block;margin-top: 2px;margin-right: 5px"/>
                    <span>订单管理</span>
                </div>
            </div>
        </div>
        <div class="fw-mb" v-if="!isCk">
            <div class="mb-item">
                <div class="mb-item-bt">
                    <i class="el-icon-s-shop" style="font-size: 18px;margin-right: 18px"/>
                    <span style="color: #999999;font-size: 13px;margin-left: -50%">{{deptName}}</span>
                    <span style="font-size: 13px">{{currentDate}}</span>
                </div>
                <div class="mb-item-gls">
                    <div class="gls-sp">
                        <span class="t">访问量</span>
                        <span class="b">{{service.fwl==null?'0':service.fwl}}</span>
                    </div>
                    <div class="gls-sp">
                        <span class="t">成交总计(单)</span>
                        <span class="b">{{service.cjNum==null?'0':service.cjNum}}</span>
                    </div>
                    <div class="gls-sp">
                        <span class="t">成交金额(元)</span>
                        <span class="b">{{service.cjAmount==null?'0':service.cjAmount}}</span>
                    </div>
                </div>
            </div>
        </div>
        <van-popup v-model="showPoster">
            <div id="imageWrapper1">
                <div class="content_container">
                    <vue-canvas-poster v-if="!posterImg" :widthPixels="595" :heightPixels="842" :painting="painting"
                                       @success="success" @fail="fail">
                    </vue-canvas-poster>
                    <van-image :src="posterImg" id="mypic" class="hb-img" crossOrigin="anonymous"/>
                </div>
            </div>
            <!--      <div style="background-color:#484848;opacity:1;display: block;">-->
            <!--        <van-button type="danger" style="width: 100%;height: 38px;line-height: 38px" @click="toSaveImage(posterImg)">保存图片</van-button>-->
            <!--      </div>-->
        </van-popup>
        <div style="height: 50px;"></div>
    </div>
</template>

<script>
    import {getCookie} from "../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                fwUser: {},
                deptId: '',
                token: '',
                currentDate: '',
                deptName: '',
                service: {},
                userType: '',
                isCk: false,
                userInfo: {},

                showPoster: false,
                posterImg: '',//生成的海报
                painting: {
                    views: []
                },
                touxiang: '',
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.userType = this.fwUser.userType
            this.getUserInfo()
            this.getDate()
            this.getMyWork()
        },
        methods: {
            async getUserInfo() {
                let data = {
                    token: this.token,
                }
                let res = await this.$get("/fw/getUserInfo", data)
                this.userInfo = res.user
            },
            async getMyWork() {
                let data = {
                    token: this.token,
                }
                let res = await this.$get("/fw/getFwZbWork", data)
                this.deptName = res.deptName
                this.isCk = res.isCk
                if (res.service) {
                    this.service = res.service
                }
            },

            //秒杀分析
            toMsAnalysis() {
                this.$router.push('/msanalysis')
            },
            // 运营分析
            toOperate() {
                this.$router.push('/operate')
            },
            //订单管理
            toOrder() {
                this.$router.push('/orderAnalysis')
            },
            //推广分析
            toTg() {
                this.$router.push('/tgAnalysis')
            },

            // 门店续费
            toRenew() {
                this.$router.push('/renew')
            },
            // 订单管理
            toOrders() {
                this.$router.push('/myorder')
            },

            //获取当前日期
            getDate() {
                const today = new Date();
                var month = today.getMonth() + 1
                if (month < 10) {
                    month = '0' + (today.getMonth() + 1).toString()
                }
                var day = today.getDate()
                if (day < 10) {
                    day = '0' + today.getDate().toString()
                }
                this.currentDate = today.getFullYear() + '-' + (month) + '-' + day;
            },
            
            //生成海报
            async toPoster() {
                this.showPoster = true
                let data = {
                    token: this.token,
                }
                let res = await this.$get("/fw/getUserPoster", data)
                var pmName = res.pmName == null ? '未开通' : res.plusName
                var touxiang=''
                if (res.sex == 1) {
                    touxiang = require('./../../assets/nan.png')
                } else {
                    touxiang = require('./../../assets/nv.png')
                }
                this.painting = {
                    position: 'relative',
                    width: '595px',
                    height: '842px',
                    background: '#FFFFFF',
                    views: [
                        {
                            type: 'image',
                            url: res.qrCode,
                            css: {
                                position: 'absolute',
                                right: '26%',
                                top: '28%',
                                color: '#000',
                                background: '#fff',
                                width: '288px',
                                height: '288px',
                                borderWidth: '40px',
                                borderColor: '#fff',
                            },
                        },
                        {
                            type: "text",
                            text: "- 长按识别查看 -",
                            css: {
                                top: "63%",
                                right: '25%',
                                width: "300px",
                                maxLines: 1,
                                textAlign: "center",
                                fontSize: "32px",
                                color: "#D3D3D3",
                            },
                        },
                        {
                            type: 'image',
                            url: touxiang,
                            css: {
                                position: 'absolute',
                                top: '9%',
                                left: '22%',
                                color: '#000',
                                background: '#fff',
                                width: '80px',
                                height: '80px',
                                borderRadius: '60px',
                            },
                        },
                        {
                            type: "text",
                            text: res.userName,
                            css: {
                                top: "9%",
                                left: "40%",
                                width: "250px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "32px",
                                color: "#8B8A8A",
                            },
                        },
                        {
                            type: "text",
                            text: "PLUS: " + pmName,
                            css: {
                                top: "15%",
                                left: "41%",
                                height: "30px",
                                padding: "5px",
                                lineHeight: "25px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "20px",
                                color: "#8B8A8A",
                                background: "#eeeeef",
                            },
                        },
                        {
                            type: 'image',
                            url: require('./../../assets/md.png'),
                            css: {
                                position: 'absolute',
                                top: '76%',
                                left: '28.5%',
                                color: '#000',
                                background: '#fff',
                                width: '58px',
                                height: '58px',
                            },
                        },
                        {
                            type: "text",
                            text: res.deptName,
                            css: {
                                top: "76%",
                                left: "38%",
                                width: "200px",
                                height: "30px",
                                lineHeight: "25px",
                                maxLines: 1,
                                textAlign: "center",
                                fontSize: "45px",
                                color: "#8B8A8A",
                            },
                        },
                    ],
                }
            },

            // 保存图片到本地
            toSaveImage(img) {
            },

            // 海报生成
            success(src) {
                this.posterImg = src
            },

            //赋值
            handleUpdateBg(row) {
                this.posterImg = ''
                this.painting.views[0].url = row.qrUrl
            },

            fail() {

            },
        },
    };
</script>

<style lang="scss" scoped>
    .fw-userinfo {
        display: flex;
        flex-direction: row;
        padding: 12px;
        background-color: #FDF7F1;
    }

    .u-img {
        width: 50px;
        height: 50px;
    }

    .u-info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 8px 8px 5px 8px
    }

    .fw-ywbl {
        padding: 12px 10px;
    }

    .fw-ywbl-bt {
        border-left: #00ACEF solid 4px;
        display: flex;
        flex-direction: column;
        padding-left: 5px;
        height: 25px;
    }

    .fw-ywbl-bt span {
        height: 15px;
        font-size: 12px;
    }

    .fw-home-menu {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-top: 10px;
    }

    .fw-menu-item {
        flex: 1;
        box-sizing: border-box;
        font-size: 10px;
        text-align: center;
        margin: 10px 5px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: calc((100% - 40px) / 4); // 我这里一行显示4个 所以是/4  一行显示几个就除以几
        min-width: calc((100% - 40px) / 4);
        max-width: calc((100% - 40px) / 4);

        &:nth-child(4n + 4) {
            margin-right: 0;
        }
    }

    .fw-menu-item img {
        width: 29px;
        height: 29px;
    }

    .fw-menu-item span {
        margin-top: 10px;
    }

    .fw-mb {
        margin-top: 10px;
        padding: 18px 12px;
    }

    .mb-item {
        height: 120px;
        background-color: #F6F6F6;
        border-radius: 5px;
        padding: 15px;
    }

    .mb-item-bt {
        font-size: 13px;
        border-bottom: silver solid 1px;
        padding-bottom: 6px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        line-height: 18px;
    }

    .mb-item-gls {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-top: 15px;
    }


    .gls-sp {
        width: 33%;
        display: flex;
        flex-direction: column;
        text-align: center;
        padding: 8px;
    }

    .gls-sp .t {
        font-size: 13px;
    }

    .gls-sp .b {
        font-size: 17px;
        color: red;
        padding-top: 16px;
    }

    ::v-deep .van-tabs__line {
        background-color: #2E3191;
        width: 98px;
    }

    .content_container {
        width: 256px;
        height: 356px;
        overflow: hidden;
        margin: auto;
        background-size: 100% 100%;
    }

    .hb-img {
        width: 256px;
        height: 356px;
        background-size: 100% 100%;
    }

</style>
